const binding = { modules: {}, dataActions: {} };

    (binding.modules['britax-buybox-swatches'] = {
        c: () => require('partner/modules/britax-buybox-swatches/britax-buybox-swatches.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'britax-buybox-swatches',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/britax-buybox-swatches'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|britax-buybox-swatches|britax-buybox-swatches'] = {
                c: () => require('partner/modules/britax-buybox-swatches/britax-buybox-swatches.view.tsx'),
                cn: '__local__-__local__-britax-buybox-swatches'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };